import { getRequest, postRequest } from "../../../system/server-call";
import responseHandler from "../../../system/server-response-handler";
import { API_URLS } from "../constants";

const { SURVEY_INBOX, USER_RESPONSES } = API_URLS;

//Getting user responses detail
const getAllBrandsResponses = (createDateFrom, createDateTo, body) => {
  return postRequest(
    `${USER_RESPONSES.GET_BRAND_RESPONSES}/${createDateFrom}/${createDateTo}`,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getAllBrandsConversionResponses = (
  createDateFrom,
  createDateTo,
  body
) => {
  return postRequest(
    `${USER_RESPONSES.GET_BRAND_SURVEY_CONVERSION_RATE_KPI}/${createDateFrom}/${createDateTo}`,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getSurveyConversionRateKpiSummary = (createDateFrom, createDateTo) => {
  return getRequest(
    `${USER_RESPONSES.GET_SURVEY_CONVERSION_RATE_KPI_SUMMARY}/${createDateFrom}/${createDateTo}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getInboxConversationData = (
  createDateFrom,
  createDateTo,
  platformId,
  body
) => {
  return postRequest(
    `${SURVEY_INBOX.GET_INBOX_CONVERSATION_DATA}/${createDateFrom}/${createDateTo}/${platformId}`,
    body
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getInboxConversationDataByBrandId = (
  createDateFrom,
  createDateTo,
  brandId,
  from = 0,
  take = 15
) => {
  return getRequest(
    `${SURVEY_INBOX.GET_INBOX_CONVERSATION_DATA_FOR_STORE}/${createDateFrom}/${createDateTo}/${brandId}?from=${from}&take=${take}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

const getInboxConversationSummary = (
  createDateFrom,
  createDateTo,
  orderPlatformType
) => {
  return getRequest(
    `${SURVEY_INBOX.GET_INBOX_CONVERSATION_SUMMARY}/${createDateFrom}/${createDateTo}/${orderPlatformType}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
};

export const performanceService = {
  getAllBrandsResponses,
  getInboxConversationData,
  getInboxConversationSummary,
  getAllBrandsConversionResponses,
  getSurveyConversionRateKpiSummary,
  getInboxConversationDataByBrandId,
};
